module.exports = __webpack_public_path__ + "media/images/common/header/area-9576e7c4abc5cf8c5c4131f0f02abe19.svg";